<template>
    <div v-if="userDetailsLoaded && $route.meta.hideHeader !== true" class="header py-1 bg-white">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-6 d-flex align-items-center">
                    <div class="logo">
                        <router-link :to="{name: 'Dashboard'}">
                            <img width="95" height="50" src="@/assets/images/logos/logo.svg" alt="digostics">
                        </router-link>
                    </div>

                    <div class="ml-4">
                        <router-link :to="{name: 'Dashboard'}" class="header-nav-item font-weight-bold mx-2">Dashboard</router-link>
                        <router-link :to="{name: 'SelectAPatient'}" class="header-nav-item font-weight-bold mx-2">Patients</router-link>
                    </div>
                </div>

                <div class="col-6">
                    <div class="d-flex justify-content-end align-items-center">
                        <span class="font-weight-bold mr-3">{{ myOrganisaion.name }}</span>
                        <button v-if="$route.name == 'Dashboard'" @click="refreshDashboard()" onclick="this.blur();" class="btn btn-yellow btn-form sm-shadow d-none d-md-block">Refresh</button>
                        
                        <div class="my-account">
                            <span class="initials text-capitalize">{{ userInitials }}</span>
                            <b-dropdown right :text="`${formatTitle(userTitle)} ${userFullName}`" variant="header-dropdown" class="text-capitalize">
                                <b-dropdown-item :to="{name: 'MyAccount'}" class="dropdown-item">My account</b-dropdown-item>
                                <b-dropdown-item target="_blank" class="dropdown-item" href="https://support.gttathome.com">Help</b-dropdown-item>
                                <b-dropdown-item target="_blank" class="dropdown-item" href="https://support.gttathome.com/support/tickets/new">Report an issue</b-dropdown-item>
                                <b-dropdown-item :to="{name: 'Notifications'}" class="dropdown-item">Notifications</b-dropdown-item>
                                <b-dropdown-item :to="{name: 'HCPTraining'}" class="dropdown-item">Training</b-dropdown-item>
                                <b-dropdown-item v-if="myOrganisaionSettings.hcpPrivacyPolicyUrl" :href="myOrganisaionSettings.hcpPrivacyPolicyUrl" target="_blank" class="dropdown-item">Privacy policy</b-dropdown-item>
                                <b-dropdown-item class="dropdown-item" @click="logout">Sign out</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import FormatterMixin from '../../../../Common/mixins/FormatterMixin'
export default {
    name: 'HeaderComponent',

    mixins: [
        FormatterMixin
    ],

    computed: {
        ...mapGetters({
            isUserAuthenticated: 'UserStore/GetIsUserAuthenticated',
            userDetailsLoaded: 'UserStore/GetUserDetailsLoaded',
            userInitials: 'UserStore/GetUserInitials',
            userFullName: 'UserStore/GetUserFullName',
            userTitle: 'UserStore/GetUserTitle',
            hasChosenFacility: 'UserStore/GetHasUserChosenAFacility',
            facilityId: 'UserStore/GetUserFacilityId',
            myOrganisaion: 'OrganisationStore/GetMyOrganisation',
            myOrganisaionSettings: 'OrganisationStore/GetMyOrganisationSettings'
        }),

        facilityIdComputed: {
            get: function() {
                return this.facilityId
            }, 

            set: function(val) {
                let facility = this.myFacilities.find(x => x.id == val)

                if(facility) {
                    this.setFacility(facility)
                }
            }
        }
    },

    methods: {
        ...mapActions({
            clearSearchStore: 'SearchStore/ClearSearchStore',
            setDashboardRefresh: 'SearchStore/SetDashboardRefresh',
            signout: 'UserStore/Signout'
        }),

        refreshDashboard() {
            this.setDashboardRefresh(true)
        },

        async logout() {
            await this.signout()
        }
    }
}
</script>